import { ToastrService } from "ngx-toastr";
import { TranslateService } from "@ngx-translate/core";
import {
  Component,
  OnInit,
  Input,
  ChangeDetectorRef,
  ViewChild,
} from "@angular/core";
import { MediaObserver, MediaChange } from "@angular/flex-layout";
import { Subscription } from "rxjs";
import * as _ from "lodash";
import { MatDialog } from "@angular/material/dialog";
import { OrdersModalComponent } from "./modal/orders-modal.component";
import { LoginService } from "src/app/services/login/login.service";
import { GetDatePipe } from "src/app/pipes/pipes/pipe-date.pipe";
import { ActivatedRoute } from "@angular/router";
import { ModalComponent } from "src/app/components/modal/modal.component";
import { Apollo } from "apollo-angular";
import { MatTableDataSource } from "@angular/material/table";
import { EditOTModalComponent } from "./modal/editOT/editOTmodal.component";
import { OrdenesServiceService } from "src/app/services/ordenes/ordenes-service.service";
import { MatPaginator } from "@angular/material/paginator";
import { TableService } from "src/app/services/table/table.service";
import { mongoMaestrosRequest } from "src/app/models/graphQL/mongoMaestros.request";
import { FormControl, FormGroup } from "@angular/forms";

export interface OrderItem {
  orden: number;
  colada: string;
  clave: string;
  modelo: string;
  disp: number;
  inicio: string;
  fin: string;
  duracion: string;
  bandejas: any;
  piezas: number;
  kgs: number;
  estado: string;
}

export interface OrderDocumentItem {
  id: number;
  tipo: string;
  nombre: string;
  fecha: string;
  operario: string;
}

export interface OrderCommentItem {
  id: number;
  tipo: string;
  valor: string;
  fecha: string;
  operario: string;
}

export interface OrderSampleItem {
  id: number;
  unidad: string;
  valor: number;
  fecha: string;
  operario: string;
}

export interface OrderTrayItem {
  id: number;
  bandeja: string;
  valor: number;
  fecha: string;
  operario: string;
}

const ELEMENT_DATA_DOCUMENTS: OrderDocumentItem[] = [{ id: 1, tipo: "PDF", nombre: "Doc 1", fecha: "2020/11/04 10:04:23", operario: "1111" }, { id: 2, tipo: "PDF", nombre: "Doc 2", fecha: "2020/11/04 18:14:43", operario: "1111" }];
const ELEMENT_DATA_COMMENTS: OrderCommentItem[] = [{ id: 1, tipo: "Comentario", valor: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla feugiat sagittis felis quis ornare. Maecenas tincidunt quis neque sed condimentum. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Suspendisse et tortor maximus, elementum felis vel, tempus ipsum. Suspendisse sed porta ante. Suspendisse non quam pharetra, volutpat ligula id, euismod libero.", fecha: "2020/11/04 10:04:23", operario: "1111" }, { id: 2, tipo: "Incidencia", valor: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla feugiat sagittis felis quis ornare. Maecenas tincidunt quis neque sed condimentum. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Suspendisse et tortor maximus, elementum felis vel, tempus ipsum. Suspendisse sed porta ante. Suspendisse non quam pharetra, volutpat ligula id, euismod libero. Mauris tristique erat vel dictum porttitor. Integer pretium libero ut pharetra eleifend. Nunc lobortis leo vitae nisi consectetur sollicitudin. Aliquam ex dui, laoreet vel enim non, interdum dictum odio. Suspendisse ornare iaculis odio vel condimentum. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Vestibulum eu enim sodales, suscipit elit a, vulputate nisl. Aenean sagittis mollis nisl, quis pellentesque est suscipit nec.", fecha: "2020/11/04 18:14:43", operario: "1111" }, { id: 3, tipo: "Comentario", valor: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla feugiat sagittis felis quis ornare. Maecenas tincidunt quis neque sed condimentum. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Suspendisse et tortor maximus, elementum felis vel, tempus ipsum. Suspendisse sed porta ante. Suspendisse non quam pharetra, volutpat ligula id, euismod libero.", fecha: "2020/11/04 10:04:23", operario: "1111" }, { id: 4, tipo: "Incidencia", valor: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla feugiat sagittis felis quis ornare. Maecenas tincidunt quis neque sed condimentum. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Suspendisse et tortor maximus, elementum felis vel, tempus ipsum. Suspendisse sed porta ante. Suspendisse non quam pharetra, volutpat ligula id, euismod libero. Mauris tristique erat vel dictum porttitor. Integer pretium libero ut pharetra eleifend. Nunc lobortis leo vitae nisi consectetur sollicitudin. Aliquam ex dui, laoreet vel enim non, interdum dictum odio. Suspendisse ornare iaculis odio vel condimentum. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Vestibulum eu enim sodales, suscipit elit a, vulputate nisl. Aenean sagittis mollis nisl, quis pellentesque est suscipit nec.", fecha: "2020/11/04 18:14:43", operario: "1111" }];
const ELEMENT_DATA_SAMPLES: OrderSampleItem[] = [{ id: 1, unidad: "HB", valor: 175, fecha: "2020/11/04 10:04:23", operario: "1111" }, { id: 2, unidad: "HB", valor: 178, fecha: "2020/11/04 18:14:43", operario: "1111" }, { id: 3, unidad: "HB", valor: 175, fecha: "2020/11/04 10:04:23", operario: "1111" }, { id: 4, unidad: "HB", valor: 178, fecha: "2020/11/04 18:14:43", operario: "1111" }, { id: 5, unidad: "HB", valor: 175, fecha: "2020/11/04 10:04:23", operario: "1111" }, { id: 6, unidad: "HB", valor: 178, fecha: "2020/11/04 18:14:43", operario: "1111" }, { id: 7, unidad: "HB", valor: 175, fecha: "2020/11/04 10:04:23", operario: "1111" }, { id: 8, unidad: "HB", valor: 178, fecha: "2020/11/04 18:14:43", operario: "1111" }];
const ELEMENT_DATA_TRAYS: OrderTrayItem[] = [{ id: 1, bandeja: "Entrada 1", valor: 17, fecha: "2020/11/04 10:04:23", operario: "1111" }, { id: 2, bandeja: "Salida 2", valor: 17, fecha: "2020/11/04 18:14:43", operario: "1111" }];


@Component({
  selector: "app-ordenes",
  templateUrl: "./orders.component.html",
  styleUrls: ["./orders.component.scss"],
  providers: [GetDatePipe],
})
export class OrdersComponent implements OnInit {
  formMode = "";
  isAdmin = false;
  loadingText = "LOADING.ORDERS";
  loading = false;
  interval: any;

  mobileMode: boolean = false;
  private mediaSub: Subscription;
  userId: string;
  userRole: any;
  filter = "";

  displayedColumns: string[];
  dataSource: MatTableDataSource<any>;
  displayedColumnsDocs: string[];
  dataSourceDocs: any;
  displayedColumnsComments: string[];
  dataSourceComments: any;
  displayedColumnsSamples: string[];
  dataSourceSamples: any;
  displayedColumnsTrays: string[];
  dataSourceTrays: any;
  new_status: string;
  loadingOrders: boolean = true;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  exportOrdersDataForm: FormGroup = new FormGroup({});
  initDate: any;
  endDate: any;

  13;
  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private mediaObserver: MediaObserver,
    private loginService: LoginService,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private toastrService: ToastrService,
    private ordersService: OrdenesServiceService,
    private translateService: TranslateService,
    private apollo: Apollo
  ) {}

  isAdminUser() {
    this.userRole = this.loginService.currentUserValue.rol;

    this.displayedColumns = [
      "orden",
      "colada",
      "clave",
      "modelo",
      "disp",
      "inicio",
      "fin",
      "duracion",
      "piezas",
      "kgs",
      "estado",
      "visualizar",
    ];
    if (
      this.userRole.includes("admin") ||
      this.userRole.includes("orders-manager")
    ) {
      this.displayedColumns.push("acciones");
      this.displayedColumns = [
        "orden",
        "colada",
        "clave",
        "bono",
        "modelo",
        "disp",
        "inicio",
        "fin",
        "duracion",
        "piezas",
        "kgs",
        "estado",
        "visualizar",
      ];
      if (
        this.userRole.includes("admin") ||
        this.userRole.includes("orders-manager")
      ) {
        this.displayedColumns.push("acciones");
        this.isAdmin = true;
      }
    }
  }

  ngOnInit() {
    this.interval = setInterval(() => {
      this.retrieveOrdersData(); 
    }, 18* Math.pow(10,5));

    this.isAdminUser();
    this.exportOrdersDataForm.addControl("initDate", new FormControl(null));
    this.exportOrdersDataForm.addControl("endDate", new FormControl(null));
    this.filter = this.route.snapshot.paramMap.get('filter');
    this.mediaSub = this.mediaObserver.media$.subscribe(
      (change: MediaChange) => {
        if (change.mqAlias == "xs" || change.mqAlias == "sm") {
          this.mobileMode = true;
        } else {
          this.mobileMode = false;
        }
      }
    );

    this.userId = this.loginService.currentUserValue.uuid;
    this.isAdminUser();

    this.retrieveOrdersData();

    this.displayedColumnsDocs = [
      "id",
      "tipo",
      "nombre",
      "fecha",
      "operario",
      "acciones",
    ];
    this.dataSourceDocs = ELEMENT_DATA_DOCUMENTS;

    this.displayedColumnsComments = [
      "tipo",
      "fecha",
      "valor",
      "operario",
      "acciones",
    ];
    this.dataSourceComments = ELEMENT_DATA_COMMENTS;

    this.displayedColumnsSamples = [
      "unidad",
      "valor",
      "fecha",
      "operario",
      "acciones",
    ];
    this.dataSourceSamples = ELEMENT_DATA_SAMPLES;

    this.displayedColumnsTrays = [
      "id",
      "bandeja",
      "valor",
      "fecha",
      "operario",
      "acciones",
    ];
    this.dataSourceTrays = ELEMENT_DATA_TRAYS;
  }

  retrieveOrdersData() {
    this.ordersService.retrieveOrdersData("ots").subscribe(({ data, loading }) => {
      this.dataSource = new MatTableDataSource(data.retrieveOrdersData);
      if(this.isAdmin != true)
        this.dataSource.data = this.dataSource.data.filter(o => o.estado == 'ot_not_started' || o.estado ==  'ot_started')

      for(let i=0; i<this.dataSource.data.length;i++) {
          this.dataSource.data[i].estado_translated = this.translateService.instant(
            `PROCESS_STATUS.${this.dataSource.data[i].estado}`
          )
        }
      this.dataSource.paginator = this.paginator;
      this.loadingOrders = loading;
    })

  }

  ngAfterInit() {
    this.changeDetectorRef.detectChanges();
  }

  ngOnDestroy(): void {
    this.mediaSub.unsubscribe();
    if (this.interval) {
      clearInterval(this.interval);
    }

  }

  openDialog(id, option, row) {
    this.setNewStatusString(row.estado);
    switch (option) {
      case 0:
        this.dialog.open(ModalComponent, {
          data: {
            title: "Opción: " + option,
            id: id,
            content: "Operación de Edición de la OF",
            option: option,
            clave: row.clave,
          },
        });
        break;
      case 1:
        this.dialog
          .open(ModalComponent, {
            data: {
              title: "Opcion: " + option,
              id: id,
              content: "Operación de Borrado de la OF",
              option: option,
              row: row,
              collection: "ots",
            },
          })
          .componentInstance.toastRequest.subscribe((response) => {
            if (response.deleteOT && response.deleteOT == 1) {
              this.toastrService.success(
                "OT borrada exitosamente",
                "Borrado exitoso"
              );
              this.retrieveOrdersData();
            } else {
              this.toastrService.error(
                "Por favor, verifique los parámetros",
                "Borrado erroneo"
              );
            }
          });

        break;
      case 2:
        const dialogRefProceso = this.dialog.open(ModalComponent, {
          width: "50%",
          data: {
            title: "Registro de Actividad de la orden: " + row.orden,
            id: id,
            content: "Monitorización del proceso",
            option: option,
            new_status: this.new_status,
            status: row.estado,
            row: row,
          },
        });

        dialogRefProceso.componentInstance.toastRequest.subscribe(
          (response) => {
            if (response.updateOT && !response.errors) {
              this.retrieveOrdersData();
              this.toastrService.success("Orden actualizada correctamente", "");
            }
            if (response.error)
              this.toastrService.success(
                "Ha habido un error al realizar la acción",
                ""
              );
          }
        );
        break;
      case 3:
        this.dialog.open(ModalComponent, {
          width: "50%",
          data: {
            title: "Gestión de la Documentación",
            id: id,
            content: "Operación de Borrado de la OF",
            option: option,
            datasource: this.dataSourceDocs,
            datasourceCols: this.displayedColumnsDocs,
          },
        });
        break;
      case 4:
        const dialogComentarios = this.dialog.open(ModalComponent, {
          width: "70%",
          data: {
            title: "Incidencias & Comentarios de la orden: " + row.orden,
            id: id,
            content: "",
            option: option,
            status: row.estado,
            datasource: row.comentarios,
            datasourceCols: this.displayedColumnsComments,
          },
        });
        dialogComentarios.componentInstance.toastRequest.subscribe(
          (response) => {
            if (response.insertComentario && !response.errors) {
              this.toastrService.success(
                "Comentario añadido correctamente",
                ""
              );
              this.retrieveOrdersData();
            }
            if (response.updateOT) {
              this.retrieveOrdersData();
            }
            if (response.deleteArrayElementFromDocument) {
              this.toastrService.success(
                "Elemento eliminado correctamente",
                ""
              );
              this.retrieveOrdersData();
            }
            if (response.error)
              this.toastrService.success("Ha habido un error", "");
          }
        );

        break;
      case 5:
        const dialogMuestras = this.dialog.open(ModalComponent, {
          width: "50%",
          data: {
            title: "Muestras de Calidad de la orden: " + row.orden,
            id: id,
            status: row.estado,
            content: "",
            option: option,
            datasource: row.muestras,
            datasourceCols: this.displayedColumnsSamples,
          },
        });

        dialogMuestras.componentInstance.toastRequest.subscribe((response) => {
          if (response.insertMuestra && !response.errors) {
            this.toastrService.success("Muestra añadida correctamente", "");
            this.retrieveOrdersData();
          }
          if (response.updateOT) {
            this.retrieveOrdersData();
          }
          if (response.deleteArrayElementFromDocument) {
            this.toastrService.success("Elemento eliminado correctamente", "");
            this.retrieveOrdersData();
          }
          if (response.error)
            this.toastrService.success("Ha habido un error", "");
        });
        break;
      case 6:
        const dialogBandejas = this.dialog.open(ModalComponent, {
          width: "50%",
          data: {
            title: "Bandejas de Piezas",
            id: id,
            status: row.estado,
            content: "",
            option: option,
            selected: "0",
            datasource: row.bandejas,
            datasourceCols: [
              "bandeja",
              "valor",
              "fecha",
              "operario",
              "acciones",
            ],
          },
        });

        dialogBandejas.componentInstance.toastRequest.subscribe((response) => {
          if (response.insertBandeja && !response.errors) {
            this.toastrService.success("Bandeja añadida correctamente", "");
            this.retrieveOrdersData();
          }
          if (response.updateOT) {
            this.retrieveOrdersData();
          }
          if (response.deleteArrayElementFromDocument) {
            this.toastrService.success("Elemento eliminado correctamente", "");
            this.retrieveOrdersData();
          }
          if (response.error)
            this.toastrService.success("Ha habido un error", "");
        });

        dialogBandejas.afterClosed().subscribe((response) => {
          if (response.closed == true) this.retrieveOrdersData();
        });
        break;
      case 7:
        this.ordersService.getSingleOFData("ots", row._id).subscribe(
          (data) => {
            let countBandejasSalida = 0;
            let ofConsigna = {};
            let of = data.data.retrieveSingleOrderData;
            let maxDureza = 0;
            let minDureza = 0;
            let avgDureza = 0;
            let sumDureza = 0;
            if (of.bandejas.length > 0) {
              for (let i = 0; i < of.bandejas.length; i++) {
                if (of.bandejas[i].tipo.includes("alida"))
                  countBandejasSalida =
                    countBandejasSalida + of.bandejas[i].cantidad;
              }
            }
            // Calculo de las durezas Maximas/Minimas/Media
            if (of.muestras.length > 0) {
              let muestrasArray: number[] = [];
              for (let i = 0; i < of.muestras.length; i++) {
                muestrasArray.push(of.muestras[i].valor);
                sumDureza = sumDureza + of.muestras[i].valor;
              }
              maxDureza = Math.max.apply(null, muestrasArray);
              minDureza = Math.min.apply(null, muestrasArray);
              avgDureza = sumDureza / of.muestras.length;
            }
            let maestrosModels = [];
            this.apollo
              .query<any>({
                query: mongoMaestrosRequest,
                variables: {
                  _id: "maestros",
                },
              })
              .subscribe(
                ({ data, errors }) => {
                  maestrosModels = data.findMaestros;

                  for (let i = 0; i < maestrosModels.length; i++) {
                    if (maestrosModels[i].modelo == of.modelo.modelo) {
                      ofConsigna = maestrosModels[i];
                    }
                  }

                  this.dialog.open(ModalComponent, {
                    width: "50%",
                    data: {
                      title: "Informe de Producción",
                      id: id,
                      content: "",
                      option: option,
                      //datasource: this.dataSourceTrays,
                      //datasourceCols: this.displayedColumnsTrays,
                      date: new Date().toLocaleDateString(),
                      order: of,
                      consigna: ofConsigna,
                      samples: of.muestras,
                      sampleMax: maxDureza,
                      sampleMin: minDureza,
                      sampleAvg: avgDureza,
                      trays: of.bandejas,
                      traysTotal: countBandejasSalida,
                      comments: of.comentarios,
                      //timeseries: TEMP_DATA,
                      graph_data: {},
                      graph_config: {},
                      new_status: this.new_status,
                      status: row.estado,
                      row: row,
                    },
                  });
                },
                (err) => {
                  console.log(err);
                }
              );
          },
          (err) => {
            console.log(err);
          }
        );
        break;
      case 15:
        this.ordersService
          .retrieveOrdersData("ots")
          .subscribe(({ data, loading }) => {
            let inicio =
              this.exportOrdersDataForm.get("initDate").value.unix() * 1000;
            let fin =
              this.exportOrdersDataForm.get("endDate").value.unix() * 1000;
            let ofs = data.retrieveOrdersData;
            let cols = [
              "orden",
              "colada",
              "clave",
              "bono",
              "modelo",
              "disp",
              "inicio",
              "fin",
              "duracion",
              "piezas",
              "kgs",
              "estado",
            ];
            let countBandejasSalida = 0;
            let maxDureza = 0;
            let minDureza = 0;
            let avgDureza = 0;
            let sumDureza = 0;
            let orders = [];
            for (let i = 0; i < ofs.length; i++) {
              let of = ofs[i];
              if (of.fin <= fin && of.fin >= inicio) {
                if (of.bandejas.length > 0) {
                  for (let i = 0; i < of.bandejas.length; i++) {
                    if (of.bandejas[i].tipo.includes("alida"))
                      countBandejasSalida =
                        countBandejasSalida + of.bandejas[i].cantidad;
                  }
                  of.bandejas = countBandejasSalida;
                }
                // Calculo de las durezas Maximas/Minimas/Media
                if (of.muestras.length > 0) {
                  let muestrasArray: number[] = [];
                  for (let i = 0; i < of.muestras.length; i++) {
                    muestrasArray.push(of.muestras[i].valor);
                    sumDureza = sumDureza + of.muestras[i].valor;
                  }
                  maxDureza = Math.max.apply(null, muestrasArray);
                  minDureza = Math.min.apply(null, muestrasArray);
                  avgDureza = sumDureza / of.muestras.length;
                  of.maxDureza = maxDureza.toFixed(2);
                  of.minDureza = minDureza.toFixed(2);
                  of.avgDureza = avgDureza.toFixed(2);
                }
                orders.push(of);
              }
            }
            this.dialog.open(ModalComponent, {
              width: "75%",
              data: {
                title: "Informe de Producción",
                id: id,
                content: "",
                option: option,
                inicio: inicio,
                fin: fin,
                datasource: orders,
                datasourceCols: cols,
                date: new Date().toLocaleDateString(),
                orders: orders,
              },
            });
          });
        break;
    }
  }

  doOpenDialog(row: any, type: string) {
    switch (type) {
      case "createOT":
        const dialogRef = this.dialog.open(OrdersModalComponent, {
          width: "25%",
        });
        dialogRef.componentInstance.toastRequest.subscribe((response) => {
          if (response.insertOT && response.insertOT == 1) {
            this.toastrService.success(
              "OT insertada exitosamente",
              "Creación exitosa"
            );
            this.retrieveOrdersData();
          } else {
            this.toastrService.error(
              "Por favor, verifique los parámetros",
              "Inserción erronea"
            );
          }
        });
        break;

      case "editOT":
        this.dialog
          .open(EditOTModalComponent, {
            width: "20%",
            data: {
              title: "edit_ot_modal_title",
              row: row,
            },
          })
          .componentInstance.toastRequest.subscribe((response) => {
            if (response.updateOT && !response.errors) {
              this.toastrService.success(
                "OT editada exitosamente",
                "Edición exitosa"
              );
              this.retrieveOrdersData();
            } else {
              this.toastrService.error(
                "Por favor, verifique los parámetros",
                "Edición erronea"
              );
            }
          });
        break;
    }
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  setNewStatusString(status: string) {
    this.new_status = "";
    switch (status) {
      case "ot_not_started":
      case "":
        this.new_status = "ot_started";
        break;
      case "ot_started":
        this.new_status = "ot_finished";
        break;
      case "ot_finished":
        this.new_status = "ot_finished";
        break;
      case "ot_validated":
        this.new_status = "ot_validated";
        break;
    }
  }


  refreshExportDatesControls() {
    this.initDate = this.exportOrdersDataForm.get('initDate').value;
    this.endDate = this.exportOrdersDataForm.get('endDate').value;
  }
}
